<template>
  <d-modal @close="handleClose" size="lg">
    <d-modal-header>
      <d-modal-title>
        {{ $t('order.invoiceDiffPopupTitle') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
        <p class="text-center">
            {{ $t('order.invoiceDiffPopupDesc') }}
        </p>

        <table class="table">
            <tbody>
                <tr
                    v-for="(row, index) of invoiceDiffData"
                    :key="'invoice-diff-popup-table-row-' + index"
                    :class="{
                        'table-danger': row.diff,
                        'table-success': !row.diff
                    }">
                    <td>
                        {{ $t('order.invoice.diffPopup.' + row.field) }}
                    </td>
                    <td>
                        {{ row.customerValue }}
                    </td>
                    <td>
                        {{ row.orderValue }}
                    </td>
                </tr>
            </tbody>
            <thead>
                <tr>
                    <th>{{ $t('order.invoiceField') }}</th>
                    <th>{{ $t('order.invoiceCustomerValue') }}</th>
                    <th>{{ $t('order.invoiceOrderValue') }}</th>
                </tr>
            </thead>
        </table>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        :outline="true"
        @click.prevent="cancel">
        {{ $t('ui.close') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="danger"
        @click.prevent="forceInvoiceRequest()">
        {{ $t('order.forceInvoiceRequestAnyway') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
export default {
  name: 'invoice-diff-popup',
  props: [
    'invoiceDiffData'
  ],
  methods: {
    handleClose () {
      this.$bus.$emit('close-invoice-diff-popup');
    },
    forceInvoiceRequest () {
      this.$bus.$emit('force-invoice-settlement-request');
      this.cancel();
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
